export default __webpack_public_path__ + "static/media/create-cd-account-icon.8a1382e8.svg";